import React, { useState, useEffect } from 'react';
import api from '../../api/api'; // Adjust import as needed

// Get today's date in YYYY-MM-DD format
const getToday = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

const LeavesForm = () => {
  const [formData, setFormData] = useState({
    start_date: '',
    end_date: '',
    days: 0,
    reason: '',
  });

  // Auto-calculate days when dates change
  useEffect(() => {
    if (formData.start_date && formData.end_date) {
      const start = new Date(formData.start_date);
      const end = new Date(formData.end_date);
      const diffTime = end - start;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

      setFormData((prev) => ({
        ...prev,
        days: diffDays > 0 ? diffDays : 0,
      }));
    }
  }, [formData.start_date, formData.end_date]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit form data
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/apply/leaves', formData);
      console.log('Leave submitted:', response.data);
      alert('Leave submitted successfully');
      setFormData({
        start_date: '',
        end_date: '',
        days: 0,
        reason: '',
      });
    } catch (error) {
      console.error('Error submitting leave:', error);
      alert('Error submitting leave');
    }
  };

  return (
    <section className="leaves-section">
      <div className="container">
        <div className="inner-content">
          <div className="content-box">
            <h2>Leave Requests</h2>
            <form onSubmit={handleSubmit}>
              <div className="filed-data">
                <label>Start Date</label>
                <input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  required
                  min={getToday()}
                />
              </div>

              <div className="filed-data">
                <label>End Date</label>
                <input
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                  required
                  min={formData.start_date || getToday()}
                />
              </div>

              <div className="filed-data">
                <label>Total Days</label>
                <input
                  type="number"
                  name="days"
                  value={formData.days}
                  readOnly
                />
              </div>

              <div className="filed-data">
                <label>Reason</label>
                <input
                  type="text"
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="submit-btn">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeavesForm;
